<div class="card-body"> 
    <h3 style="color: #000;">Thank you for requesting a quotation from Insure My Alpaca. Please confirm:</h3>
    <div class="form-group alert alert-primary mb-1" *ngFor="let ques of agreedQuestions;">
        {{ques.text}}
    </div>
    
    <div class="form-group mt-2">
        <button (click)="agreedBtnAction()" class="btn btn-success btn-sm">Agree</button>
    </div>
</div>